import React from 'react';
import { Container, Message, Subtitle, Top, WidthMessage } from './FormContainer.styles';
import { ReactComponent as Logo } from '../../../assets/icons/logo-form.svg';

const FormContainer = ({ message, children, gap, subtitle, widthMessage }) => {
  return (
    <Container $gap={gap}>
      {message ? (
        <Top>
          <Logo />
          <Message>{message}</Message>
        </Top>
      ) : (
        <>
          <Logo />
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          {widthMessage && <WidthMessage>{widthMessage}</WidthMessage>}
        </>
      )}

      {children}
    </Container>
  );
};

export default FormContainer;
